import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {Container, Stack, Typography} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import withMainContainer from '../components/WithMainContainer.js';
import {LoaderComp} from '../components/Loader.js';
import SCButton from '../components/SCButton.js';
import {useQueryParam} from '../util/react_hooks.js';
import api from '../util/api.js';
import config from '../config.js';
import {getEnv} from '../util.js';

const PaymentCheckComp = props=>{
    let {data, loading} = props;
    let [ipn] = useQueryParam('ipn');
    if (data?.status=='expired')
    {
        return <>
          <ErrorOutlineIcon color="error" sx={{fontSize: 100}}/>
          <Typography variant="h3" textAlign="center">
            פג תוקף הקישור
          </Typography>
        </>;
    }
    if (data?.status=='COMPLETE')
    {
        return <>
          <TaskAltIcon color="success" sx={{fontSize: 100}}/>
          <Typography variant="h3" textAlign="center">
            תודה על הרכישה
          </Typography>
          <Stack direction="row" flexWrap="wrap" gap={2}
            justifyContent="center" alignItems="center">
            {data.docUrl&&<SCButton variant="outlined" text="הורדת קבלה"
              icon={<DownloadIcon/>}
              onClick={()=>window.open(data.docUrl)}/>}
            {data.comment&&<Typography>
              {data.comment}
            </Typography>}
          </Stack>
        </>;
    }
    if (data?.status=='PENDING')
    {
        return <>
          <LoaderComp/>
          <Typography textAlign="center">
            התשלום מתבצע, זה יקח רק כמה רגעים...
          </Typography>
          {getEnv()=='DEV'&&<SCButton text="Test IPN"
            onClick={()=>api.product.ext.testIpn({external_data: ipn})}/>}
        </>;
    }
    if (loading)
        return <LoaderComp/>;
};

const ProductPurchaseComplete = ()=>{
    let [data, setData] = useState();
    let [loading, setLoading] = useState();
    let [paymentId] = useQueryParam('paymentId');
    let [paymentToken] = useQueryParam('paymentToken');
    useEffect(()=>{
        if (!paymentId||!paymentToken)
            return;
        setLoading(true);
        let es, itvl;
        let connect = ()=>{
            es = api.product.getPaymentEvents(paymentId, paymentToken);
            es.onerror = e=>{
                console.error('EventSource error', e);
                itvl = setTimeout(()=>connect(), 3000);
            };
            es.addEventListener('waiting', ()=>setData({status: 'PENDING'}));
            es.addEventListener('purchase_complete', ev=>{
                setData(JSON.parse(ev.data));
                setLoading(false);
                es.close();
            });
        };
        connect();
        return ()=>{
            clearTimeout(itvl);
            setLoading(false);
            es.close();
        };
    }, [paymentId, paymentToken]);
    return <Container maxWidth="lg">
      <Stack direction="column" alignItems="center" gap={2}
        marginBottom={8} marginTop={5}>
        <PaymentCheckComp data={data} loading={loading}/>
      </Stack>
    </Container>;
};

export default withMainContainer(ProductPurchaseComplete);
